import {PageTitle} from '../../../_metronic/layout/core';
import {useIntl} from 'react-intl';
import Services from '../Components/Services';
import {useQuery} from 'react-query';
import {ListService} from '../Types/service';
import {getServicesByClient} from '../Api/api';

const MonParcPage = (): JSX.Element => {
  const intl = useIntl();
  const {isLoading, data: services} = useQuery<ListService[]>(['get-service-by-client'], () =>
    getServicesByClient()
  );

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.MY_FLEET'})}</PageTitle>
      <Services
        isLoading={isLoading}
        services={services}
        title={intl.formatMessage({id: 'SERVICES.TITLE'})}
        showConnexionInsights={false}
        showTypeFilter={false}
        showCategoryFilter
      />
    </>
  );
};

export default MonParcPage;
